import { render, staticRenderFns } from "./PremiumLawyerOfficeProfileForm.vue?vue&type=template&id=c766092a"
import script from "./PremiumLawyerOfficeProfileForm.vue?vue&type=script&lang=js"
export * from "./PremiumLawyerOfficeProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports